import React from 'react';
import { Gift, Zap, ClipboardCheck, MessageCircle, Map } from 'lucide-react';
import { CTAButton } from './CTAButton';
const bonuses = [{
  number: 1,
  title: 'Plan B Docente',
  description: '40 actividades salvavidas. Rompe-hielos y consignas rápidas.',
  icon: <Zap className="w-5 h-5" data-id="element-13" />,
  color: 'from-cyan-500/20 to-blue-500/20',
  borderColor: 'border-cyan-500/20',
  iconColor: 'text-cyan-400'
}, {
  number: 2,
  title: 'Pack Evaluar sin Estrés',
  description: 'Evaluaciones trimestrales, TPs y rúbricas listas para usar.',
  icon: <ClipboardCheck className="w-5 h-5" data-id="element-14" />,
  color: 'from-emerald-500/20 to-teal-500/20',
  borderColor: 'border-emerald-500/20',
  iconColor: 'text-emerald-400'
}, {
  number: 3,
  title: 'Conversaciones que Sí Funcionan',
  description: 'Guía para abordar temas sensibles con adolescentes reales.',
  icon: <MessageCircle className="w-5 h-5" data-id="element-15" />,
  color: 'from-amber-500/20 to-orange-500/20',
  borderColor: 'border-amber-500/20',
  iconColor: 'text-amber-400'
}, {
  number: 4,
  title: 'Mapa Anual de Contenidos',
  description: 'Todo el año en una sola hoja. Los 5 Tomos en secuencia ideal.',
  icon: <Map className="w-5 h-5" data-id="element-16" />,
  color: 'from-violet-500/20 to-purple-500/20',
  borderColor: 'border-violet-500/20',
  iconColor: 'text-violet-400'
}];
export function Bonuses() {
  return <section id="bonos" className="py-16 bg-brand-darker text-white px-4 border-y border-white/5" data-id="element-17">
      <div className="max-w-4xl mx-auto" data-id="element-18">
        <div className="text-center mb-10" data-id="element-19">
          <div className="inline-flex items-center justify-center gap-2 bg-brand-accent text-white px-4 py-1.5 rounded-full font-heading font-bold text-sm mb-4 uppercase" data-id="element-20">
            <Gift className="w-4 h-4" data-id="element-21" />
            <span data-id="element-22">GRATIS por el día de hoy</span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold mb-2 uppercase" data-id="element-23">
            Bonos Exclusivos
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-10" data-id="element-24">
          {bonuses.map(bonus => <div key={bonus.number} className={`bg-gradient-to-br ${bonus.color} border ${bonus.borderColor} rounded-xl p-4 text-center hover:scale-[1.03] transition-transform duration-200`} data-id="element-25">
              <div className={`${bonus.iconColor} mx-auto mb-2`} data-id="element-26">
                {bonus.icon}
              </div>
              <h3 className="text-sm font-heading font-bold text-white mb-1 uppercase" data-id="element-27">
                {bonus.title}
              </h3>
              <p className="text-[11px] text-gray-400 leading-snug font-body" data-id="element-28">
                {bonus.description}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-29">
          <p className="text-base md:text-lg font-body font-bold text-white mb-5" data-id="element-30">
            Valor total de los 4 bonos:{' '}
            <span className="line-through text-gray-500" data-id="element-31">$29.990</span>{' '}
            <span className="text-brand-accent mx-1" data-id="element-32">—</span> Por el día de hoy
            → <span className="text-brand-accent italic font-bold" data-id="element-33">GRATIS</span>
          </p>
          <CTAButton text="👉 Quiero el pack completo + los bonos" className="w-full md:w-auto" data-id="element-34" />
        </div>
      </div>
    </section>;
}